import autodeskSvgGreyUrl from '../assets/images/autodesk-svg-grey.svg'
import autodeskSvgWhiteUrl from '../assets/images/autodesk-svg-white.svg'
import iconUnifierGray from '../assets/images/icon_unifier_gray.png'
import iconUnifierWhite from '../assets/images/icon_unifier_white.png'

import { isAutodeskBuildIntegrationBranding } from './autodeskBuildIntegration'

/** Context menu / card icons for Procore-backed integration flows */
export const integrationMenuGreyIcon = isAutodeskBuildIntegrationBranding
  ? autodeskSvgGreyUrl
  : iconUnifierGray

export const integrationMenuWhiteIcon = isAutodeskBuildIntegrationBranding
  ? autodeskSvgWhiteUrl
  : iconUnifierWhite
